import { render } from "./romaneio-coletor-editar.vue?vue&type=template&id=ca57fd88&scoped=true"
import script from "./romaneio-coletor-editar.vue?vue&type=script&lang=js"
export * from "./romaneio-coletor-editar.vue?vue&type=script&lang=js"

import "./romaneio-coletor-editar.vue?vue&type=style&index=0&id=ca57fd88&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca57fd88"]])

export default __exports__